export type ElectronSmsNotificationContext = {
  activeDid: string | null;
  activeConversationId: string | null;
};

let context: ElectronSmsNotificationContext = {
  activeDid: null,
  activeConversationId: null,
};

export function getElectronSmsNotificationContext(): ElectronSmsNotificationContext {
  return context;
}

export function setElectronSmsNotificationContext(
  partial: Partial<ElectronSmsNotificationContext>
): void {
  context = { ...context, ...partial };
}
